(function () {
  'use strict';

  angular
    .module('specsguardApp')
    .factory('areaTemplateBusinessLogic', areaTemplateBusinessLogic);

  areaTemplateBusinessLogic.$inject = [];

  function areaTemplateBusinessLogic () {
    return {
      groupAndFlattenAreaTemplates: function groupAndFlattenAreaTemplates (templates) {
        const parents = {};
        templates.forEach((template) => {
          if (template.isParent) {
            parents[template._id] = Object.assign(template, {children: []}, parents[template._id]);
          } else if (parents[template.parentId]) {
            parents[template.parentId].children.push(template);
          } else {
            parents[template.parentId] = {children: [template]};
          }
        });

        let flattened = [];
        Object.keys(parents).forEach((key) => {
          flattened.push(parents[key]);
          flattened = [...flattened, ...parents[key].children];
        });
        return flattened;
      }
    };
  }
})();
